import { InfoIconButton } from '@mote/ui'
import styled from '@xstyled/styled-components'

export const StyledInfoIconButton = styled(InfoIconButton)<{
  size: number
}>(props => ({
  '& span.button-icon': {
    color: props.theme.colors.grey.d2,
    width: props.size,
    height: props.size
  }
}))
